/* eslint-disable no-unused-vars */
/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import Grid from "@mui/material/Grid";
import axios from "axios";
import { appConstants } from "utils/appConstants";
import React, { useContext, useEffect, useState } from "react";
import TimelineItem from "components/Icon/TimelineItem";
import { useNavigate, useParams } from "react-router-dom";
import checkCircleIcon from 'assets/images/gif_Icons/checkCircleIcon.gif';
import invoiceLoaded from 'assets/images/gif_Icons/invoiceLoaded.gif';
import WarningIcon from '@mui/icons-material/Warning';
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import QuotationLayout from "layouts/authentication/components/QuotationLayout/QuotationLayout";
import DataTable, { createTheme } from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import MDTypography from "components/MDTypography";
import SignatureModel from "components/signatureModel/signatureModel";
import swal from "sweetalert";
import { SocketContext } from "socket/SocketContext";
import { colorScheme } from "default";
import LoadingModal from "components/LoadingModel/loadingModal";
import { ArrowDropDown } from "@mui/icons-material";
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // increase the width
  height: "90%x", // increase the height
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
let expiryDate;

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "#202940",
    },
    context: {
      background: "#202940",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);



function ContactViewAgree() {
  const navigate = useNavigate();
  //Starts here change the pagination text Rows per page to Record per page
  // let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  // if (changePaginationText !== undefined) {
  //   changePaginationText.getElementsByTagName("span")[0].textContent = "Records Per Page";
  // }  //ends here change the pagination text Rows per page to Record per page

  const { id: QuotationID } = useParams();
  const { quotationNumber: contactType } = useParams();
  const type = new URLSearchParams(window.location.search).get("type");
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);

  const [showQuotationSection, setShowQuotationSection] = useState(false);
  const [confirmationMesssage, setconfirmationMessage] = useState(false);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "", itemPrice: "", itemQuantity: "", gst: "", priceValidity: "None",
      priceValidityValue: "", discountType: "None", discountValue: "", discountAmount: ""
    },
  ]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    display: 'grid',
    justifyContent: 'center'
  };
  const [values, setValues] = useState({
    quotationID: undefined,
    quotationNumber: 'Auto Generated',
    contactID: '',
    purchaseOrderNumber: '',
    quotationDate: new Date(),
    validUpto: "Same Day",
    validUptoDate: new Date(),
    quotationStatus: 'Pending',
    gstType: "Inclusive",
    totalGSTAmount: 0,
    totalAmount: 0,
    totalDiscountAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
  })

  const [quoDocuments, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSignatureDialogeFlag, setShowSignatureDialogeFlag] = useState(false);
  const [currencyCode, setCurrencyCode] = useState("");
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const socket = useContext(SocketContext);
  const [status, setStatus] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      await FetchPendingQuotationForCustomer();
    };
    fetchData();
  }, []);




  const FetchPendingQuotationForCustomer = async () => {
    setLoading(true);
    await axios.post(appConstants.baseURL + 'contact/fetchPendingContactsForSupplier', { quotationID: QuotationID }).then(res => {
      console.log("dataaaasss", res.data)
      if (res.data.Result_Status) {

        let data = res.data.Result_Output[0];
        console.log("dataaaa", data)


        if (contactType !== data.contactType) {
          navigate(`/contact/${data.contactType}/${data._id}`);
        }

        if (data.contactVerifiedStatus === "Verified") {
          setconfirmationMessage(`${data.name} already Verified. Thanks for Verified the ${data.contactType}.`);
          setShowQuotationSection(false);
        } else {
          setShowQuotationSection(true);
          // setCurrencyCode(data.currencyValue);
          // data.itemsList.length > 0 && setValues(data);
          // data.itemsList.length > 0 && setItemRowValues(data.itemsList);
          // data.documentsList.length > 0 && setDocuments(data.documentsList);
        }
      } else {
        console.error("Error: ", res.data.Result_Message);
      }
      setLoading(false);
    }).catch(error => {
      console.error("Error in fetchPendingQuotationForCustomer: ", error);
    })
  }

  const customStyles = {

    table: {

      style: {
        borderColor: "lightgray",
      },
    },
    headRow: {
      style: {
        minHeight: '30px'
      },
    },
    headCells: {
      style: {
        fontSize: "12px",
      },
    },
    cells: {
      style: {

      },
    },
  };

  // let columns = [
  //   {
  //     name: "Item Name",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         value={row.itemName}
  //         variant="outlined"
  //         disabled
  //         fullWidth
  //       />

  //     ),
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //       display: "block"
  //     },
  //   },
  //   {
  //     name: "Item Price",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         value={row.itemPrice}
  //         variant="outlined"
  //         disabled
  //         fullWidth

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "Item Quantity",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         value={row.itemQuantity}
  //         variant="outlined"
  //         disabled
  //         fullWidth

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "GST (%)",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.gst}
  //         disabled
  //         style={{ cursor: 'default', pointerEvents: 'none' }}

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   // {
  //   //   name: "Price Validity",
  //   //   selector: (row, i) => (

  //   //     <Select
  //   //       style={{ height: "44.11px" }}
  //   //       labelId="day-hours-select-label"
  //   //       id="day-hours-select"
  //   //       value={row.priceValidity}
  //   //       disabled
  //   //       fullWidth
  //   //       variant="outlined"
  //   //     >
  //   //       <MenuItem value="None">None</MenuItem>
  //   //       <MenuItem value="Days">Days</MenuItem>
  //   //       <MenuItem value="Hours">Hours</MenuItem>
  //   //     </Select>
  //   //   ),
  //   //   style: {
  //   //     overFlow: "scroll",
  //   //     width: "100%",
  //   //     paddingLeft: "10px",
  //   //     paddingTop: "10px",
  //   //     paddingRight: "10px",
  //   //     paddingBottom: "10px",
  //   //     display: "block"
  //   //   },
  //   //   center: true,
  //   //   className: "resss",
  //   // },
  //   // {
  //   //   name: "Validity Value",
  //   //   selector: (row, i) => (
  //   //     <TextField
  //   //       type="text"
  //   //       autoComplete="off"
  //   //       variant="outlined"
  //   //       fullWidth
  //   //       value={row.priceValidity === "None" ? 0 : row.priceValidityValue}
  //   //       disabled

  //   //     />
  //   //   ),
  //   //   center: true,
  //   //   style: {
  //   //     paddingLeft: "10px",
  //   //     paddingTop: "10px",
  //   //     paddingRight: "10px",
  //   //     paddingBottom: "10px",
  //   //   },
  //   // },
  //   {
  //     name: "Discount Type",
  //     selector: (row, i) => (
  //       <Select
  //         style={{ height: "35.11px" }}
  //         labelId="day-hours-select-label"
  //         id="day-hours-select"
  //         value={row.discountType}
  //         disabled
  //         fullWidth
  //         variant="outlined"
  //       >
  //         <MenuItem value="None">None</MenuItem>
  //         <MenuItem value="Percentage">Percentage %</MenuItem>
  //         <MenuItem value="Fixed">Fixed</MenuItem>
  //       </Select>
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px", display: "block"
  //     },
  //   },
  //   {
  //     name: "Discount Value",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.discountType === "None" ? 0 : row.discountValue}
  //         disabled

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     // name: `Discount Amount (${currencyCode})`,
  //     name: <p className="payableamount">{`Discount Amount (${currencyCode})`}</p>,
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.discountType === "None" ? 0 : row.discountAmount}
  //         disabled

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },

  // ];
  let columns = [
    {
      name: "Item Name",
      selector: row => row.itemName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Item Price",
      selector: row => row.itemPrice,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Item Quantitiy",
      selector: row => row.itemQuantity,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "GST%",
      selector: row => row.gst,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: `Discount Amount (${values.currencyValue})`,
    //   selector: row => row.discountAmount,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
  ];

  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };


  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action(s)",
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          <Grid item mt={-3.2}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => { handleViewDocument(row) }}
              title="View"
            />
          </Grid>


        </>
      ),
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: false,
  };
  const handleCancel = name => event => {
    setShowSignatureDialogeFlag(false);
  };
  const handleSignature = async (val) => {
    try {
      let formData = new FormData();
      formData.append("imageData", val);
      formData.append("quotationID", QuotationID);
      formData.append("signatureKey", appConstants.SIGNATURE_KEY);
      await axios.post(appConstants.baseURL + 'contact/verifiedContactAsSupplier', formData).then(res => {
        console.log("responseetttttttttt", res.data)
        if (res.data.Result_Status) {
          setShowSignatureDialogeFlag(false);
          setconfirmationMessage(`Contact Supplier Verified Successfully.`);
          setShowQuotationSection(false);
          socket.emit('message', { businessUserID: loginDetails?.businessUserID });

        } else {
          swal("danger", res.data.Result_Message, "warning");
          setconfirmationMessage('');
          setShowQuotationSection(true);
        }
      });

    } catch (error) {
      console.error('Error in handleSignature:', error.message);
    }
  };

  return (
    <QuotationLayout >
      <div style={{ marginTop: "20px" }}>
        {!showQuotationSection &&
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Card color="success" sx={{ display: "grid", placeItems: "center", p: 2, boxShadow: "5px 5px 5px 5px grey" }}>
              <Grid sx={{ display: "flex", justifyContent: "center", fontSize: "10rem", alignItems: "center", }} >
                {confirmationMesssage ? (<img src={checkCircleIcon} alt="success" />) : (<img src={invoiceLoaded} alt="success" />)}

              </Grid>
              <Grid sx={{ display: "flex", justifyContent: "center", fontSize: "10rem", alignItems: "center", }} >
                <Typography sx={{ display: "flex", justifyContent: "center", fontSize: "2rem", alignItems: "center", fontWeight: "bold" }} >Invoice & Recover</Typography>

              </Grid>
              <Grid sx={{ display: "flex", justifyContent: "center", fontSize: "10rem", alignItems: "center", }} >
                <Typography sx={{ display: "flex", justifyContent: "center", fontSize: "1.8rem", fontWeight: "bold", alignItems: "center", fontFamily: "poppins" }} >Thank You!</Typography>
              </Grid>


              <Grid item xs={12} md={4} lg={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 2 }}>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  color="success"
                  sx={{ cursor: "pointer", userSelect: "none", justifyContent: "center", alignItems: "center", fontSize: "1rem", fontSize: "18px" }}
                >
                  {confirmationMesssage}
                </MDTypography>
              </Grid>
            </Card>
          </div>
        }
        {showQuotationSection && <>
          <Card color="primary" sx={{ paddingBottom: "20px" }}>
            <PageTitle screenName="Verify for Supplier" />

            <Box sx={{ px: 3, mt: 2 }}>
              <Typography variant="h6" gutterBottom>
                Demo Supplier Agreement
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-line" }}>
                This Supplier Agreement ("Agreement") is made between [Your Company Name] ("Company")
                and [Supplier Name] ("Supplier"). The Supplier agrees to provide goods or services
                in accordance with the Company’s quality standards, delivery schedules, and pricing terms.

                Key Terms:
                1. Payment Terms: Payment will be made within 30 days of invoice receipt.
                2. Confidentiality: The Supplier shall maintain confidentiality of all Company data.
                3. Termination: Either party may terminate this Agreement with 30 days’ written notice.
                4. Compliance: Supplier shall comply with all applicable laws and ethical standards.

                This is a demo version for display purposes only.
              </Typography>
            </Box>


            <Grid
              container
              mt={2}
              pb={3}
              spacing={2}
              alignItems="center"
              justifyContent="center"
              style={{ display: "flex" }}
            >
              <Grid
                item
                xs={12}
                md={4}
                lg={1.423}
                container
                justifyContent="center"
              >
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  onClick={() => { setShowQuotationSection(false) }}
                  style={{ height: "40px", width: "165px" }}
                >
                  Close
                </MDButton>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={1.423}
                container
                justifyContent="center"
              >
                <MDButton
                  rel="noreferrer"
                  variant="gradient"
                  color="success"
                  onClick={() => { setShowSignatureDialogeFlag(true) }}
                  style={{ height: "40px", width: "165px" }}
                >
                  Sign & Approve
                </MDButton>
              </Grid>
            </Grid>

          </Card>
        </>
        }
      </div>
      {
        showSignatureDialogeFlag ? (
          <SignatureModel
            open={showSignatureDialogeFlag}
            sign={handleSignature}
            handleCancel={handleCancel('handleCancel')}
            closeModalClick={handleCancel('closeModalClick')}
            titleMsg="Do you want to Verify the Supplier by Signing it?"
          />
        ) : (
          <Modal
            open={showSignatureDialogeFlag}
            // onClose={props.closeModalClick}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                  <WarningIcon style={{ color: "orange", fontSize: 40 }} />
                </Typography>
                <Typography variant="h6" component="h2" style={{ color: "black" }}>
                  {"You have crossed the expiry date."}
                </Typography>
                <Grid container sx={{ mt: 2, justifyContent: "center" }}>
                  <MDButton color="error" className="modalButton"
                    sx={{ textTransform: "capitalize" }}
                    onClick={() => { setShowSignatureDialogeFlag(false) }}
                  >

                    Close
                  </MDButton>
                </Grid>
              </Box>
            </Card>
          </Modal>

        )
      }

      <Modal
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          '& .MuiModal-root': {
            width: '100%',
            height: '100%',
          },
        }}
      >
        <Card sx={pdfStyle}>
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              File Viewer
            </Typography>
            <iframe title="File Viewer" src={getDocumentFileURL} width="100%" height="650" frameborder="0" className="ressst" allowfullscreen={true} ></iframe>

            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>

                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>

      <LoadingModal loading={loading} />

    </QuotationLayout >
  );
}

export default ContactViewAgree;
